import PropTypes from "prop-types";
import ReactGA from "react-ga";

const OutboundLink = ({
  alt,
  ariaLabel,
  children,
  className,
  dangerouslySetInnerHTML,
  url,
  utm_medium,
  utm_source,
  title,
}) => {
  let href = url;
  try {
    const parsedUrl = new URL(href);
    parsedUrl.searchParams.set("utm_source", "edhrec");
    if (utm_medium) parsedUrl.searchParams.set("utm_medium", utm_medium);
    if (utm_source) parsedUrl.searchParams.set("utm_source", utm_source);
    href = parsedUrl.href;
  } catch (error) {
    console.warn(`Invalid URL: ${url}`);
  }
  return (
    <ReactGA.OutboundLink
      alt={alt}
      aria-label={ariaLabel}
      className={className}
      dangerouslySetInnerHTML={dangerouslySetInnerHTML}
      rel="noopener noreferrer"
      target="_blank"
      title={title}
      to={href}
      url={href}
    >
      {children}
    </ReactGA.OutboundLink>
  );
};

OutboundLink.propTypes = {
  alt: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  className: PropTypes.string,
  dangerouslySetInnerHTML: PropTypes.shape({ __html: PropTypes.string }),
  title: PropTypes.string,
  url: PropTypes.string.isRequired,
  utm_medium: PropTypes.string,
  utm_source: PropTypes.string,
};

export default OutboundLink;
